'use strict';

const _=require('pulsar-utils/dist-es6/_');


const DEFAULTS={
triggerEvent:'click',
directive:'pulsar-text-tooltip',
anchorToTargetSide:'top',
alignFromTooltipSide:'bottom'};let


TooltipDirective=class TooltipDirective{
static get type(){
return'directive';
}

factory(tooltipService){
return{
restrict:'A',
scope:{
textContent:'@pulsarTooltipText',
directive:'@pulsarTooltipDirective',
anchorToTargetSide:'@pulsarTooltipAnchor',
alignFromTooltipSide:'@pulsarTooltipAlignFrom',
leftOffset:'@pulsarTooltipLeftOffset',
bindings:'=pulsarTooltipData'},

link:(scope,element,attrs)=>{
_.defaults(scope,DEFAULTS);

const triggerEvent=attrs.pulsarTooltipTrigger||DEFAULTS.triggerEvent;

const handleTooltipTrigger=event=>{
event.preventDefault();
event.stopPropagation();

if(tooltipService.currentTarget===event.target)return;
tooltipService.closeTooltip();

const childScope=scope.$new(!1,scope);
tooltipService.openTooltip(childScope,event.target);
};

if(element[0]._registeredHandler){
return;
}

element[0]._registeredHandler=handleTooltipTrigger;



element.on(triggerEvent,handleTooltipTrigger);

scope.$on('$destroy',()=>{
delete element[0]._registeredHandler;
element.off(triggerEvent,handleTooltipTrigger);
});
}};

}};


module.exports=TooltipDirective;
module.exports.prototype.factory.$inject=['tooltipService'];
//# sourceMappingURL=tooltipDirective.js.map
